import { getApiBaseUrl } from '../lib/getApiUrl';
import { useState } from 'react';
import { BulkAction, BulkActionResult } from '../types/deliverable';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

interface UseDeliverableBulkOpsReturn {
  executeBulkAction: (action: BulkAction) => Promise<BulkActionResult>;
  isLoading: boolean;
  result: BulkActionResult | null;
}

export const useDeliverableBulkOps = (): UseDeliverableBulkOpsReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<BulkActionResult | null>(null);

  const executeBulkAction = async (action: BulkAction): Promise<BulkActionResult> => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/deliverables/bulk-action`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(action),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          (errorData as { message?: string }).message || 'Bulk action failed'
        );
      }

      const data = await response.json();
      const bulkResult: BulkActionResult = data.data || data;
      setResult(bulkResult);
      return bulkResult;
    } finally {
      setIsLoading(false);
    }
  };

  return { executeBulkAction, isLoading, result };
};

export default useDeliverableBulkOps;
